var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closePanel,
          expression: "closePanel",
        },
      ],
      staticClass: "admin-global-search",
    },
    [
      _c(
        "div",
        {
          staticClass: "admin-global-search__field",
          attrs: { role: "search" },
        },
        [
          _c("span", {
            staticClass: "admin-global-search__command-dot",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("admin-icon", {
            staticClass: "admin-global-search__icon",
            attrs: { name: "search", "aria-hidden": "true" },
          }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.query,
                expression: "query",
              },
            ],
            ref: "input",
            staticClass: "admin-global-search__input",
            attrs: {
              type: "search",
              placeholder: _vm.trans("general.search_placeholder"),
              autocomplete: "off",
              autocorrect: "off",
              spellcheck: "false",
              role: "combobox",
              "aria-label": _vm.trans("general.search_placeholder"),
              "aria-autocomplete": "list",
              "aria-haspopup": "listbox",
              "aria-controls": _vm.listboxId,
              "aria-activedescendant":
                _vm.panelOpen && _vm.activeOptionId
                  ? _vm.activeOptionId
                  : false,
              "aria-expanded": _vm.panelOpen ? "true" : "false",
            },
            domProps: { value: _vm.query },
            on: {
              focus: _vm.onFocus,
              keydown: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  )
                    return null
                  $event.preventDefault()
                  return _vm.closePanel.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "down", 40, $event.key, [
                      "Down",
                      "ArrowDown",
                    ])
                  )
                    return null
                  $event.preventDefault()
                  return _vm.moveActive(1)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "up", 38, $event.key, [
                      "Up",
                      "ArrowUp",
                    ])
                  )
                    return null
                  $event.preventDefault()
                  return _vm.moveActive(-1)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.goActive.apply(null, arguments)
                },
              ],
              input: function ($event) {
                if ($event.target.composing) return
                _vm.query = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "kbd",
            {
              staticClass: "admin-global-search__kbd d-none d-md-inline-flex",
              attrs: { "aria-hidden": "true" },
            },
            [_vm._v("/")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.panelOpen,
              expression: "panelOpen",
            },
          ],
          staticClass: "admin-global-search__panel admin-pro-dropdown-panel",
          attrs: { id: _vm.listboxId, role: "listbox" },
        },
        [
          _vm.loading
            ? _c("div", { staticClass: "admin-global-search__state" }, [
                _vm._v(_vm._s(_vm.trans("general.searching"))),
              ])
            : [
                _vm.queryTrim.length > 0 && _vm.queryTrim.length < 2
                  ? _c("div", { staticClass: "admin-global-search__state" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.trans("general.search_min_chars")) +
                          "\n            "
                      ),
                    ])
                  : _vm.queryTrim.length >= 2
                  ? [
                      _vm.navHits.length
                        ? _c(
                            "div",
                            { staticClass: "admin-global-search__section" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "admin-global-search__section-label",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans("general.search_section_nav")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "admin-global-search__list" },
                                _vm._l(_vm.navHits, function (item, idx) {
                                  return _c(
                                    "li",
                                    {
                                      key: "n-" + item.path,
                                      attrs: { role: "presentation" },
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "admin-global-search__item",
                                          class: {
                                            "is-active": _vm.flatIndex === idx,
                                          },
                                          attrs: {
                                            id: _vm.optionId(idx),
                                            to: item.path,
                                            role: "option",
                                            "aria-selected":
                                              _vm.flatIndex === idx
                                                ? "true"
                                                : "false",
                                          },
                                          nativeOn: {
                                            click: function ($event) {
                                              return _vm.onPick.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "admin-global-search__item-icon",
                                              attrs: { "aria-hidden": "true" },
                                            },
                                            [
                                              _c("admin-icon", {
                                                attrs: { name: "grid" },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "admin-global-search__item-body",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "admin-global-search__item-title",
                                                },
                                                [_vm._v(_vm._s(item.label))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "admin-global-search__item-meta",
                                                },
                                                [_vm._v(_vm._s(item.path))]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.entityBlocks.length
                        ? _c(
                            "div",
                            { staticClass: "admin-global-search__section" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "admin-global-search__section-label",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans(
                                        "general.search_section_records"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.entityBlocks, function (block) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      key: block.type,
                                      staticClass:
                                        "admin-global-search__entity",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "admin-global-search__entity-type",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.entityTitle(block.type))
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "admin-global-search__list",
                                        },
                                        _vm._l(block.items, function (it, j) {
                                          return _c(
                                            "li",
                                            {
                                              key:
                                                block.type +
                                                "-" +
                                                j +
                                                "-" +
                                                it.path,
                                              attrs: { role: "presentation" },
                                            },
                                            [
                                              _c(
                                                "router-link",
                                                {
                                                  staticClass:
                                                    "admin-global-search__item",
                                                  class: {
                                                    "is-active":
                                                      _vm.flatIndex ===
                                                      _vm.navHits.length +
                                                        _vm.flatEntityIndex(
                                                          block,
                                                          j
                                                        ),
                                                  },
                                                  attrs: {
                                                    id: _vm.optionId(
                                                      _vm.navHits.length +
                                                        _vm.flatEntityIndex(
                                                          block,
                                                          j
                                                        )
                                                    ),
                                                    to: it.path,
                                                    role: "option",
                                                    "aria-selected":
                                                      _vm.flatIndex ===
                                                      _vm.navHits.length +
                                                        _vm.flatEntityIndex(
                                                          block,
                                                          j
                                                        )
                                                        ? "true"
                                                        : "false",
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.onPick.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "admin-global-search__item-icon",
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    },
                                                    [
                                                      _c("admin-icon", {
                                                        attrs: {
                                                          name: "chevron",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "admin-global-search__item-body",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "admin-global-search__item-title",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(it.title)
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      it.subtitle
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "admin-global-search__item-meta",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  it.subtitle
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      ),
                                    ]
                                  ),
                                ]
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.navHits.length &&
                      !_vm.entityBlocks.length &&
                      !_vm.loading
                        ? _c(
                            "div",
                            { staticClass: "admin-global-search__state" },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.trans("general.search_no_results")
                                  ) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : _c("div", { staticClass: "admin-global-search__hint" }, [
                      _vm._v(_vm._s(_vm.trans("general.search_hint_shortcut"))),
                    ]),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }